import React from 'react';
import { Container, Row, Image } from 'react-bootstrap';

function HomePage() {

  return (
    <Container
      fluid
      className="p-0 d-flex justify-content-center align-items-center"
      style={{ height: '100vh', width: '50vw' }}
    >
      <Row>
        <img
          src="/images/tomte_logo.svg"
          alt="Large Background"
          className="img-fluid"
          style={{ maxHeight: '100%', maxWidth: '100%' }}
        />
      </Row>
    </Container>
  );
}


export default HomePage;